import Model from './BaseModel';
import MarketSetGroup from './MarketSetGroup';

export default class MarketGroupSet extends Model {
	resourceName() {
		return 'market_group_sets';
	}

	fields() {
		return ['name', 'sport', 'is_default'];
	}

	relationships() {
		return {
			market_set_groups: new MarketSetGroup()
		};
	}

	create(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}

	update(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}`,
			method: 'PATCH',
			data
		});
	}
}
